import * as Yup from 'yup';

export const overviewValidationSchema = Yup.object().shape({
    title: Yup.string().required('app.error.required'),
    responsibleContact: Yup.mixed().required('app.error.required'),
    customerAccount: Yup.mixed().required('app.error.required'),
    customerContact: Yup.mixed().required('app.error.required'),
    supplierAccount: Yup.mixed().required('app.error.required'),
    deliveryAddress: Yup.mixed().required('app.error.required'),
    invoiceAddress: Yup.mixed().when('supplierAccount.isChargingSupplier', {
        is: false,
        then: Yup.mixed().required('app.error.required'),
    }),
    orderDate: Yup.date().required('app.error.required').typeError('app.error.required'),
    currency: Yup.string().required('app.error.required'),
    functionalAsset: Yup.mixed().when('requireFunctionalAssets', {
        is: true,
        then: Yup.mixed().required('app.error.required'),
    }),
});
